<template>
  <main>
    <menu-tab
      :menu="menu"
      :swiper="true"
      :slidesPerView="4"
      @change="selectMenu"
    ></menu-tab>

    <product-card
      :list="{ data: plist }"
      name="productdetail"
      tid="0"
      v-show="currentMenuItem == menu[0]"
    ></product-card>
    <topic-item :topicData="{ data: tzlist }"  v-show="currentMenuItem == menu[1]"></topic-item>

    <doc-item
      :docData="{ data: wklist }"
      v-show="currentMenuItem == menu[2]"
    ></doc-item>
  </main>
  <empty
    v-if="
      (currentMenuItem == menu[0] && !plist.length) ||
      (currentMenuItem == menu[1] && !tzlist.length) ||
      (currentMenuItem == menu[2] && !wklist.length)"
    :text="currentMenuItem"
  ></empty>
  <loading :options="loadOption" v-if="loading"></loading>

</template>


<script lang="ts">
import { defineComponent, onMounted, ref, nextTick, reactive } from "vue";

// import list from "@/components/common/list.vue";

import MenuTab from "@/components/common/MenuTab.vue";
import Toast from "@/components/UI/Toast/";
import TopicItem from "@/components/common/TopicItem.vue";
import productCard from "@/components/common/productCard.vue";
import DocItem from "@/components/common/DocItem.vue";
//ts
import {
  productMap,
  IproductList,
} from "@/hooks/useProduct";

//  utils
import axios from "@/api/axios";
import Loading from "@/components/UI/Loading/index";
import Empty from "@/components/common/Empty.vue";

export default defineComponent({
  name: "Collection",
  components: {
    MenuTab,
    TopicItem,
    DocItem,
    productCard,
    Loading,
    Empty
  },

  setup() {
    //  切换列表菜单
    type Menu = "标物" | "帖子" | "文库";
    const menu: Menu[] = ["标物", "帖子", "文库"];
    const currentMenuItem = ref(menu[0]);
    function selectMenu(item: Menu) {
      currentMenuItem.value = item;
    }

    //   Data Source
    const plist = reactive<object[]>([]);
    const wklist = reactive<any[]>([]);
    const tzlist = reactive<any[]>([]);
    const loading = ref(true);
    axios
      .get("/M/User/CollectionNew")
      .then((res) => {
        if (res.data.success) {
          const data = res.data.obj;
          console.log(data);
          data.plist.forEach((item: IproductList) => {
            plist.push(productMap(item));
          });
          data.tzlist.forEach((item: any) => {
            tzlist.push(item);
          });
          data.wklist.forEach((item: any) => {
            wklist.push(item);
          });

        } else {
          Toast({
            type: "error",
            title: res.data.msg,
          });
        }
         loading.value = false;
      })
      .catch((err) => {
         loading.value = false;
        console.log('err')
      });
    const loadOption = {
      text: "加载中...",
      color: "#df0024",
      textColor: "#df0024",
    };
    return {
      menu,
      selectMenu,
      currentMenuItem,
      plist,
      tzlist,
      wklist,
      loading,
      loadOption,
    };
  },
});
</script>

<style lang="scss" scoped>
main {
  padding-bottom: 55px;
}
</style>
